module.exports = __webpack_public_path__ + "img/组 362 拷贝 3(1).fb767957.png";